import React from 'react';
import './EvaluatorInterface.css';

const Loader = ({ title, description, compact = false, fullScreen = false }) => {
    const loaderTitle = title || 'Carregando dados';
    const loaderDescription = description === undefined ? "Aguarde enquanto preparamos seu ambiente." : description;

    return (
        <div className={`${fullScreen ? 'evaluator-loading-screen' : ''}`}>
            <div className={`evaluator-loading-state ${compact ? 'is-compact' : ''}`} role="status" aria-live="polite">
                <span className="evaluator-loading-icon" aria-hidden="true">
                    <i className="mdi mdi-loading"></i>
                </span>
                <span className="evaluator-loading-copy">
                    <strong>{loaderTitle}</strong>
                    {loaderDescription && <small>{loaderDescription}</small>}
                </span>
            </div>
        </div>
    );
};

export default Loader;
